import { api } from "./core";

// Database metadata API used by the Rule builder.
export const dbmetaApi = {
  listDatabases() {
    return api("/api/dbmeta/databases");
  },

  listTables(database) {
    return api(`/api/dbmeta/tables?database=${encodeURIComponent(database)}`);
  },

  listColumns(database, table) {
    return api(
      `/api/dbmeta/columns?database=${encodeURIComponent(database)}&table=${encodeURIComponent(table)}`,
    );
  },
};

